<template>
    <div class="task-base-line-wrapper">
        <div class="task-base-line" :style="{ 'height' : baselineHgt +'px' }">
            <template v-for="clockMarker in clockMarkerList">
                <div class='clock' :class="{'special' : clockMarker.special}" :style="{ 'left' : clockMarker.left +'px' }"></div>
                <div class='clock-text' :class="{'special' : clockMarker.special}" :style="{ 'left' : clockMarker.textLeft +'px' }">{{clockMarker.text}}</div>
            </template>
            <el-tooltip v-if="dayOffMarker != null" :content="dayOffMarker.title" effect="light" placement="top-start">
                <div class="dayoff" :style="{ 'left' : dayOffMarker.left +'px','width' : dayOffMarker.width +'px', 'height' : baselineHgt +'px'}"></div>
            </el-tooltip>
            <el-tooltip v-if="totalWorkMinutes != null" content="工作时长" effect="light" placement="top-start">
                <div class="minutes">{{totalWorkMinutes}} 分钟</div>
            </el-tooltip>
            <el-tooltip v-if="signinMarker != null" :content="signinMarker.title" effect="dark" placement="top-start">
                <div class='sign in' :style="{ 'left' : signinMarker.left +'px' }"></div>
            </el-tooltip>
            <el-tooltip v-if="signoutMarker != null" :content="signoutMarker.title" effect="dark" placement="top-start">
                <div class='sign out' :style="{ 'left' : signoutMarker.left +'px' }"></div>
            </el-tooltip>
            <template v-for="taskMarker in taskMarkers">
                <el-tooltip v-if="taskMarker.visible" effect="dark" placement="top-start">
                    <div slot="content" style="line-height:30px;" v-html="taskMarker.title"></div>
                    <div class='task' @click="clickHandlerProxy(taskMarker.taskId, taskMarker.allNodes)" :style="{ 'left' : taskMarker.left +'px','width' : taskMarker.width +'px','bottom' : taskMarker.bottom +'px'  }">
                        <template v-for="phase in taskMarker.phases">
                            <div class='phase' :class="phase.cssClass" :style="{ 'left' : phase.left +'px','width' : phase.width +'px' }"></div>
                        </template>
                        <img v-if="isInvalidated(taskMarker.taskId)" class="invalidated" v-resc-url="'/image/red-cross.png'"/>
                    </div>
                </el-tooltip>
            </template>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //
    let default_specialHours = [
        8,
        12,
        16,
        20
    ];
    //
    const min_baselineHgt = 24;
    //
    export default {
        name: 'swb-task-line',
        desc: '任务时间线',
        props: {
            startTime: {
                type: String,
                default: '08:00'
            },
            endTime: {
                type: String,
                default: '20:00'
            },
            specialHours: {
                type: Array,
                default: function () {
                    return [].concat(default_specialHours);
                }
            },
            taskNodeConf: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            taskPhaseConf: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            taskPhaseInfoProvider: {
                type: Function
            },
            taskClickHandler: {
                type: Function
            },
            //
            taskData: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data() {
            return {
                minTaskWidth: 5,
                //
                taskPhaseConfMap: {},
                //
                theActor: null,
                theDate: null,
                //休息时间
                dayOff: null,
                //
                signinTime: null,
                signoutTime: null,
                //
                invalidated: [],
                //
                taskNodes: [],
                // -------------------
                baselineHgt: min_baselineHgt,
                //
                totalWorkMinutes: null,
                //
                clockMarkerList: [],
                //休息时段
                dayOffMarker: null,
                //签到 x轴位置
                signinMarker: null,
                signoutMarker: null,
                //
                taskMarkers: []
            };
        },
        computed: {},
        watch: {
            startTime(newVal, oldVal) {
                this.renderTaskBarsX();
            },
            endTime(newVal, oldVal) {
                this.renderTaskBarsX();
            },
            taskData(newVal, oldVal) {
                this.renderTaskBarsX();
            }
        },
        created() {
            this.doInit();
        },
        mounted() {
            this.renderTaskBars(this.theDate, this.startTime, this.endTime, this.taskNodes, this.dayOff, this.signinTime, this.signoutTime, this.specialHours || default_specialHours);
        },
        methods: {
            clickHandlerProxy(taskId, taskNodes) {
                if(this.taskClickHandler != null) {
                    this.taskClickHandler(taskId, taskNodes);
                }
            },
            doInit() {
                let taskPhaseConf = this.taskPhaseConf || [];
                this.taskPhaseConfMap = taskPhaseConf.toMap("name");
                //
                let taskData = this.taskData || {};
                this.theActor = taskData.theActor || "";
                this.theDate = taskData.theDate || null;
                this.dayOff = taskData.dayOff || null;
                this.signinTime = taskData.signinTime || null;
                this.signoutTime = taskData.signoutTime || null;
                this.invalidated = taskData.invalidated == null ? [] : taskData.invalidated;
                this.taskNodes = taskData.taskNodes || [];
            },
            isInvalidated(taskId) {
                return this.invalidated.indexOf(taskId) != -1;
            },
            //
            getNodeId(taskNode) {
                return taskNode[this.taskNodeConf.propId];
            },
            getNodeTaskId(taskNode) {
                return taskNode[this.taskNodeConf.propTaskId];
            },
            getNodeName(taskNode) {
                return taskNode[this.taskNodeConf.propName];
            },
            getNodeTs(taskNode) {
                return taskNode[this.taskNodeConf.propTs];
            },
            getNodeValid(taskNode) {
                return taskNode[this.taskNodeConf.propValid];
            },
            //按时间点排序一天的任务节点 {id, taskId, name, ts, overlap}
            filterAndSortTaskNodesByTs(taskNodes) {
                let self = this;
                //
                taskNodes = taskNodes || [];
                //按任务id分组
                var splitted = taskNodes.split(function (taskNode) {
                    return self.getNodeTaskId(taskNode);
                });
                //console.log(splitted);
                //
                taskNodes = [];
                for(var i = 0, c = splitted.length; i < c; i++) {
                    var tmpNodes = splitted[i];
                    //去除调度无效节点
                    var startNodeFlag = false;
                    var planStartNodeIndex = -1;
                    var endNodeFlag = false;
                    var planEndNodeIndex = -1;
                    for(var j = 0; j < tmpNodes.length; j++) {
                        var taskNode = tmpNodes[j];
                        var taskNodeName = self.getNodeName(taskNode);
                        if(self.getNodeValid(taskNode) == false) {
                            //去除无效节点
                            tmpNodes.removeAt(j--);
                        } else if(taskNodeName == self.taskNodeConf.startNodeName) {
                            startNodeFlag = true;
                        } else if(taskNodeName == self.taskNodeConf.planStartNodeName) {
                            planStartNodeIndex = j;
                        } else if(taskNodeName == self.taskNodeConf.endNodeName) {
                            endNodeFlag = true;
                        } else if(taskNodeName == self.taskNodeConf.planEndNodeName) {
                            planEndNodeIndex = j;
                        }
                    }
                    //
                    var indexAdjusted = false;
                    if(startNodeFlag && planStartNodeIndex != -1) {
                        //有实际开始节点 和 计划开始节点，去除计划开始节点
                        tmpNodes.removeAt(planStartNodeIndex);
                        if(planStartNodeIndex < planEndNodeIndex) {
                            //设置预计结束节点索引调整标记
                            indexAdjusted = true;
                        }
                    }
                    if(endNodeFlag && planEndNodeIndex != -1) {
                        //有实际结束节点 和 预计结束节点，去除预节点
                        if(indexAdjusted) {
                            planEndNodeIndex--;
                        }
                        //
                        tmpNodes.removeAt(planEndNodeIndex);
                    }
                    //
                    taskNodes = taskNodes.concat(tmpNodes);
                }

                //按时间点排序
                return taskNodes.sort(function (node1, node2) {
                    var ts1 = self.getNodeTs(node1);
                    var ts2 = self.getNodeTs(node2);
                    if(ts1 == ts2) {
                        var id1 = self.getNodeId(node1);
                        var id2 = self.getNodeId(node2);
                        return id1 > id2 ? 1 : -1;
                    } else {
                        return ts1 > ts2 ? 1 : -1;
                    }
                });
            },
            //排序任务（的起始和结束任务节点）
            sortTaskNodeEndPoints(taskNodes) {
                let self = this;
                //
                var sortedTaskNodes = self.filterAndSortTaskNodesByTs(taskNodes);
                console.log(sortedTaskNodes);
                //
                var taskIds = [];
                var taskIdEndPointsMap = {};
                for(var i = 0, c = sortedTaskNodes.length; i < c; i++) {
                    var taskNode = sortedTaskNodes[i];
                    var taskId = self.getNodeTaskId(taskNode);
                    var taskEndPoints = null;
                    if(taskIds.indexOf(taskId) == -1) {
                        taskIds.add(taskId);
                        //记录起始节点（初始结束几点）
                        taskEndPoints = {
                            taskId: taskId,
                            startNode: taskNode,
                            endNode: taskNode,
                            allNodes: [taskNode]
                        };
                        //
                        taskIdEndPointsMap[taskId] = taskEndPoints;
                    } else {
                        //记录最后的结束节点
                        taskEndPoints = taskIdEndPointsMap[taskId];
                        taskEndPoints.endNode = taskNode;
                        taskEndPoints.allNodes.add(taskNode);
                    }
                }
                //
                return taskIds.map(function (taskId) {
                    return taskIdEndPointsMap[taskId];
                });
            },
            //计算任务重叠数
            calcTaskOverlaps(sortedTaskEndPoints) {
                let self = this;
                //
                //复制一份
                var sortedEndPoints = sortedTaskEndPoints.map(function (el) {
                    return el;
                });
                //
                //var totalWorkTime = 0;
                //
                while(sortedEndPoints.length > 0) {
                    var startingPoint = sortedEndPoints.shift();
                    var minWorkTime = self.getNodeTs(startingPoint.startNode);
                    var maxWorkTime = self.getNodeTs(startingPoint.endNode);
                    //
                    for(var i = 0, j = 0, c = sortedEndPoints.length; i < c; i++, j++) {
                        var taskPoints = sortedEndPoints[i];
                        var taskTs = self.getNodeTs(taskPoints.startNode);
                        if(taskTs > maxWorkTime) {
                            break;
                        }
                        taskPoints.startNode.overlap = j + 1;
                        taskTs = self.getNodeTs(taskPoints.endNode);
                        if(taskTs > maxWorkTime) {
                            maxWorkTime = taskTs;
                        }
                        //
                        sortedEndPoints.shift();
                        i--;
                        c--;
                    }
                    //totalWorkTime += Date.parseAsDate(maxWorkTime).diff(Date.parseAsDate(minWorkTime), "minute");
                    //console.log(totalWorkTime + " min");
                }
                //
                //return totalWorkTime;
            },
            //生成整点 ('2019-06-03', '8:30', '23:50')
            generateClockList(theDate, startTime, endTime) {
                startTime = Date.parseAsDate(theDate + " " + startTime);
                endTime = Date.parseAsDate(theDate + " " + endTime);
                var startHour = startTime.getHours();
                var startMinute = startTime.getMinutes();
                var endHour = endTime.getHours();
                var year = startTime.getFullYear();
                var month = startTime.getMonth();
                var day = startTime.getDate();
                var clockList = [];
                //
                if(startMinute > 0) {
                    startHour++;
                }
                for(var h = startHour; h <= endHour; h++) {
                    clockList.add(new Date(year, month, day, h, 0, 0));
                }
                return clockList;
            },
            //
            renderTaskBars(theDate, selStartTime, selEndTime, taskNodes, dayOff, signinTime, signoutTime, specialHours) {
                //重置渲染数据信息
                this.baselineHgt = min_baselineHgt;
                //
                this.totalWorkMinutes = null;
                //
                this.clockMarkerList = [];
                //
                this.dayOffMarker = null;
                //签到 x轴位置
                this.signinMarker = null;
                this.signoutMarker = null;
                //
                this.taskMarkers = [];
                //
                if(theDate == null || selStartTime == null || selEndTime == null) {
                    console.error("缺少日期信息，无法渲染");
                    return;
                }
                else {
                    console.log("渲染 " + this.theActor + " " + theDate + " 的任务条：");
                }
                //
                let self = this;
                const gap = 2;
                //
                let minTaskWidth = this.minTaskWidth;
                //
                var jqTaskBaseline = $(this.$el).find('.task-base-line');
                let baselineLen = jqTaskBaseline.width();
                //console.log(baselineLen);
                //
                var sortedEndPoints = this.sortTaskNodeEndPoints(taskNodes);
                //计算任务重叠数
                this.calcTaskOverlaps(sortedEndPoints);
                //
                console.log(sortedEndPoints);
                //记录下选择的起始时间和结束时间
                var startTimeX = selStartTime;
                var endTimeX = selEndTime;
                //时钟 + 刻度
                var clockList = this.generateClockList(theDate, selStartTime, selEndTime);
                //
                selStartTime = Date.parseAsDate(theDate + " " + selStartTime);
                selEndTime = Date.parseAsDate(theDate + " " + selEndTime);
                //
                var totalMinutes = selEndTime.diff(selStartTime, "minute");
                //console.log("totalMinutes : " + totalMinutes);
                let clockMarkerList = [];
                for(var i = 0, c = clockList.length; i < c; i++) {
                    var clockTs = clockList[i];
                    var clockMarker = {};
                    clockMarkerList[i] = clockMarker;
                    //
                    var diffMinutes = clockTs.diff(selStartTime, "minute");
                    var specialHour = specialHours.indexOf(clockTs.getHours()) != -1;
                    //console.log(clockTs.format('yyyy-MM-dd HH:mm:ss'));
                    var clockLeft = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                    if(specialHour) {
                        clockMarker.special = true;
                        clockMarker.left = clockLeft - 1;
                    }
                    else {
                        clockMarker.left = clockLeft;
                    }
                    clockMarker.text = clockTs.format("HH:mm");
                    clockMarker.textLeft = clockLeft - 20;
                }
                this.clockMarkerList = clockMarkerList;
                //休息时间
                if(dayOff != null) {
                    var dayOffStartTime = Date.parseAsDate(dayOff.startTime);
                    var dayOffEndTime = Date.parseAsDate(dayOff.endTime);
                    if(dayOffEndTime <= selStartTime || dayOffStartTime >= selEndTime) {
                        //在范围之外，忽略（不刻画休息时间）
                    }
                    else {
                        var dayOffTitle = "休息时段：" + dayOff.startTime + " 到 " + dayOff.endTime;
                        var dayOffLeft = 0;
                        //
                        if(dayOffStartTime <= selStartTime) {
                            dayOffStartTime = selStartTime;
                            dayOffLeft = 0;
                        }
                        else {
                            var diffMinutes = dayOffStartTime.diff(selStartTime, "minute");
                            dayOffLeft = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                        }
                        //
                        if(dayOffEndTime > selEndTime) {
                            dayOffEndTime = selEndTime;
                        }
                        var diffMinutes = dayOffEndTime.diff(dayOffStartTime, "minute");
                        var dayOffWidth = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                        //
                        this.dayOffMarker = {
                            title: dayOffTitle,
                            left: dayOffLeft,
                            width: dayOffWidth
                        };
                    }
                }
                //签到、签退
                if(signinTime) {
                    signinTime = Date.parseAsDate(signinTime);
                    var diffMinutes = signinTime.diff(selStartTime, "minute");
                    var signLeft = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                    //
                    if(signLeft >= 0 && signLeft <= baselineLen) {
                        this.signinMarker = {
                            left: signLeft - 4,
                            title: signinTime.format("HH:mm") + " 签到"
                        };
                    }
                }
                if(signoutTime) {
                    signoutTime = Date.parseAsDate(signoutTime);
                    var diffMinutes = signoutTime.diff(selStartTime, "minute");
                    var signLeft = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                    //
                    if(signLeft >= 0 && signLeft <= baselineLen) {
                        this.signoutMarker = {
                            left: signLeft - 4,
                            title: signoutTime.format("HH:mm") + " 签退"
                        };
                    }
                }
                //任务
                var taskMarkers = [];
                var maxOverlap = 0;
                var totalWorkMinutes = 0;
                for(var i = 0, c = sortedEndPoints.length; i < c; i++) {
                    var taskEndPoints = sortedEndPoints[i];
                    var taskId = taskEndPoints.taskId;
                    var taskStartNode = taskEndPoints.startNode;
                    var taskEndNode = taskEndPoints.endNode;
                    var allTaskNodes = taskEndPoints.allNodes;
                    //
                    var taskMarker = {
                        visible: true,
                        taskId: taskId
                    };
                    taskMarkers[i] = taskMarker;
                    //
                    var taskId = this.getNodeTaskId(taskStartNode);
                    taskMarker.taskId = taskId;
                    taskMarker.allNodes = allTaskNodes;
                    //
                    //处理重叠位置
                    var overlap = taskStartNode.overlap || 0;
                    if(overlap > 0) {
                        taskMarker.bottom = overlap * (10 + gap);
                        //
                        if(overlap > maxOverlap) {
                            maxOverlap = overlap;
                        }
                    }
                    //
                    var taskStartTime = Date.parseAsDate(this.getNodeTs(taskStartNode));
                    var taskEndTime = Date.parseAsDate(this.getNodeTs(taskEndNode));
                    var diffMinutes = taskStartTime.diff(selStartTime, "minute");
                    var taskStartLeft = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                    diffMinutes = taskEndTime.diff(taskStartTime, "minute");
                    //console.log(taskId + " : " + diffMinutes);
                    var taskTotalWidth = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                    taskTotalWidth = Math.max(taskTotalWidth, minTaskWidth);
                    var taskEndRight = taskStartLeft + taskTotalWidth;
                    if(taskEndRight <= 0 || taskStartLeft >= baselineLen) {//终止点超出左边线 或 起始点超出右边线
                        taskMarker.visible = false;
                    }
                    else {
                        if(taskStartLeft < 0) {//起始点超出左边线
                            taskStartLeft = 0;
                        }
                        if(taskEndRight > baselineLen) {//起始点超出右边线
                            taskEndRight = baselineLen;
                        }
                    }

                    taskMarker.left = taskStartLeft;
                    taskMarker.width = Math.max(0, taskEndRight - taskStartLeft);
                    taskMarker.right = taskMarker.left + taskMarker.width;
                    //
                    console.log(taskStartTime.format('yyyy-MM-dd HH:mm:ss') + "  =>  " + taskEndTime.format('yyyy-MM-dd HH:mm:ss') + " :: " + taskMarker.left + " - " + taskMarker.right);

                    var hintText = allTaskNodes.map(function (taskNode) {
                        return Date.parseAsDate(self.getNodeTs(taskNode)).format('HH:mm') + "\t" + self.getNodeName(taskNode);
                    }).join("<br/>");
                    //提示标题
                    taskMarker.title = hintText;
                    //任务样式
                    var phases = [];
                    if(typeof this.taskPhaseInfoProvider == 'function') {
                        var prevPhaseRight = 0;
                        var copiedNodes = allTaskNodes.map(function (node) {
                            return Utils.merge({}, node);
                        });
                        for(var j = 0, k = allTaskNodes.length - 1; j < k; j++) {
                            var fromNode = allTaskNodes[j];
                            var toNode = allTaskNodes[j + 1];
                            //
                            var phase = {};
                            phases[j] = phase;
                            //
                            //(fromNode, toNode, fromIndex, taskNodes) => {name, workMinutes}
                            var phaseInfo = this.taskPhaseInfoProvider(copiedNodes[j], copiedNodes[j + 1], j, copiedNodes);
                            phase.minutes = phaseInfo.workMinutes;
                            totalWorkMinutes += phase.minutes;
                            phase.cssClass = this.taskPhaseConfMap[phaseInfo.name].cssClass;
                            //
                            var phaseStartTime = Date.parseAsDate(this.getNodeTs(fromNode));
                            var phaseEndTime = Date.parseAsDate(this.getNodeTs(toNode));
                            //console.log(phaseStartTime.format('HH:mm:ss') + " => " + phaseEndTime.format('HH:mm:ss'));
                            diffMinutes = phaseStartTime.diff(selStartTime, "minute");
                            var phaseStartLeft = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                            phaseStartLeft -= taskMarker.left;//调整left（错位）
                            diffMinutes = phaseEndTime.diff(phaseStartTime, "minute");
                            var phaseTotalWidth = Math.ceil(diffMinutes * baselineLen * 1.0 / totalMinutes);
                            //
                            if(phaseStartLeft < 0) {
                                phaseStartLeft = 0;
                            }
                            //
                            var phaseEndRight = phaseStartLeft + phaseTotalWidth;
                            //
                            if(phaseEndRight > taskMarker.right - taskMarker.left) {
                                phaseEndRight = taskMarker.right - taskMarker.left;
                            }
                            phase.left = phaseStartLeft;
                            if(j > 0 && phase.left != prevPhaseRight) {
                                phase.left = prevPhaseRight;
                            }
                            phase.width = Math.max(0, phaseEndRight - phaseStartLeft);
                            phase.right = prevPhaseRight = phase.left + phase.width;
                            //console.log(phase);
                        }
                        //
                        if(prevPhaseRight + taskMarker.left > taskMarker.right) {
                            taskMarker.width = prevPhaseRight;
                        }
                    }
                    taskMarker.phases = phases;
                }
                this.taskMarkers = taskMarkers;
                //
                this.totalWorkMinutes = totalWorkMinutes;
                //计算调整外框高度
                if(maxOverlap > 0) {
                    let baselineHgt = 10 + maxOverlap * (10 + gap) + 4;
                    if(baselineHgt > min_baselineHgt) {
                        this.baselineHgt = baselineHgt;
                    }
                }
            },
            //二合一
            renderTaskBarsX() {
                this.doInit();
                //
                this.renderTaskBars(this.theDate, this.startTime, this.endTime, this.taskNodes, this.dayOff, this.signinTime, this.signoutTime, this.specialHours || default_specialHours);
            }
        }
    }
</script>

<style>
    .task-base-line-wrapper {
        padding: 10px;
        min-width: 200px;
    }

    .task-base-line {
        position: relative;
        height: 24px;
        min-height: 24px;
        background-color: #C0C4CC;
        width: 100%;
        border-radius: 2px;
    }

    .task-base-line .clock {
        position: absolute;
        height: 4px;
        background-color: #666666;
        width: 1px;
        top: -2px;
    }

    .task-base-line .clock.special {
        width: 2px;
        background-color: #000000;
    }

    .task-base-line .clock-text {
        position: absolute;
        height: 16px;
        color: #666666;
        font-size: 10px;
        width: 40px;
        top: -16px;
        text-align: center;
        vertical-align: bottom;
    }

    .task-base-line .clock-text.special {
        color: #000000;
    }

    .task-base-line .minutes {
        position: absolute;
        height: 20px;
        top: 2px;
        color: blue;
        font-size: 10px;
        left: 0px;
        line-height: 20px;
    }

    .task-base-line .dayoff {
        position: absolute;
        height: 24px;
        min-height: 24px;
        bottom: 0px;
        background-color: #777777;
        border: 1px dashed #666666;
        border-radius: 2px;
    }

    .task-base-line .task {
        position: absolute;
        height: 10px;
        border: 1px solid #75438a;
        bottom: 0px;
        border-radius: 2px;
    }

    .task-base-line .task .phase {
        position: absolute;
        height: 8px;
        bottom: 0px;
        border-width: 0;
        border-right: 1px dotted #75438a;
    }

    .task-base-line .task .invalidated {
        position: absolute;
        height: 14px;
        width: 14px;
        bottom: -3px;
        right: -7px;
    }

    .task-base-line .sign {
        position: absolute;
        height: 8px;
        width: 8px;
        top: -4px;
        border-radius: 4px;
    }

    .task-base-line .sign.in {
        border: 1px solid #0000FF;
        background-color: #28A3EF;
    }

    .task-base-line .sign.out {
        border: 1px solid #AA44DD;
        background-color: #FF44DD;
    }

</style>



// WEBPACK FOOTER //
// src/compo/task/TaskLine.vue